module.exports = __webpack_public_path__ + "static/media/register_banner.9272660d.png";